<template>
  <div class="footer-area pt-100 pb-75">
    <div class="container mw-1356">
      <div class="row">
        <div
          class="col-lg-4"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="footer-single-widget mw-250">
            <RouterLink to="/" class="d-inline-block footer-logo">
              <img :src="footerData.logo" alt="white-logo" />
            </RouterLink>
            <p>{{ footerData.description }}</p>
            <h4>وسائل التواصل الاجتماعي</h4>
            <ul class="ps-0 mb-0 list-unstyled d-flex social-links">
              <li v-for="social in footerData.socialLinks" :key="social.name">
                <a :href="social.url" target="_blank">
                  <i :class="social.icon"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-lg-8">
          <div class="row">
            <div
              v-for="(section, index) in footerData.sections"
              :key="index"
              class="col-xl-3 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="300"
            >
              <div class="footer-single-widget">
                <h3>{{ section.title }}</h3>
                <ul class="ps-0 mb-0 list-unstyled import-links">
                  <li v-for="link in section.links" :key="link.text">
                    <RouterLink :to="link.url">{{ link.text }}</RouterLink>
                  </li>
                </ul>
              </div>
            </div>

            <div
              class="col-xl-3 col-sm-6"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="400"
            >
              <div class="footer-single-widget">
                <h3>تواصل معنا</h3>
                <ul class="ps-0 mb-0 list-unstyled contact-links">
                  <li
                    v-for="contact in footerData.contact"
                    :key="contact.phone"
                  >
                    <a :href="'tel:' + contact.phone">{{ contact.phone }}</a>
                    <p class="mb-0">{{ contact.note }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from "vue";

export default defineComponent({
  name: "MainFooter",
  setup() {
    const footerData = reactive({
      logo: require("@/assets/images/white-logo.svg"),
      description: "نساعد مجتمعاتنا على التواصل، العمل، والازدهار منذ عام 1952",
      socialLinks: [
        {
          name: "Facebook",
          url: "https://www.facebook.com/",
          icon: "ri-facebook-fill",
        },
        {
          name: "Twitter",
          url: "https://www.twitter.com/",
          icon: "ri-twitter-x-fill",
        },
        {
          name: "Instagram",
          url: "https://www.instagram.com/",
          icon: "ri-instagram-fill",
        },
        {
          name: "LinkedIn",
          url: "https://www.linkedin.com/",
          icon: "ri-linkedin-fill",
        },
      ],
      sections: [
        {
          title: "الخدمات",
          links: [
            { text: "الإنترنت", url: "/services" },
            { text: "التلفزيون", url: "/services" },
            { text: "الهاتف", url: "/services" },
            { text: "الشبكات اللاسلكية المدارة", url: "/services" },
            { text: "مراكز الوصول العام (PAC’s)", url: "/services" },
          ],
        },
        {
          title: "الشركة",
          links: [
            { text: "من نحن", url: "/about-us" },
            { text: "الأسعار", url: "/pricing-plan" },
            { text: "اتصل بنا", url: "/contact-us" },
            { text: "السياسات", url: "/privacy-policy" },
            { text: "المتجر", url: "/products" },
          ],
        },
        {
          title: "معلومات",
          links: [
            { text: "المدونة", url: "/blog" },
            { text: "الدليل", url: "/about-us" },
            { text: "المصادر", url: "/about-us" },
            { text: "موقعنا على الخريطة", url: "/contact-us" },
            { text: "دفع الفاتورة", url: "/pay-bill" },
          ],
        },
      ],
      contact: [
        {
          phone: "+1 (800) 216 20 20",
          note: "(لخدمة العملاء والدعم الفني)",
        },
        { phone: "+1 (800) 216 20 21", note: "(للعملاء الجدد)" },
      ],
    });

    return { footerData };
  },
});
</script>